/** Strenge til delte åbningstider, helligdage og lukninger (#1256, #1231). */
export const translationLivechat_da_schedules = {
  livechatOpeningHours: "Åbningstider",
  livechatOpeningHoursHint: "Skemaer, helligdage og lukninger, som chatbots deler",
  livechatHolidaysClosures: "Helligdage og særlige åbningstider",
  livechatSchedulesDescription:
    "Hver chatbot følger ét skema eller har sine egne tider. En ændring gælder med det samme for alle chatbots på skemaet.",
  livechatSchedulesEmpty: "Ingen skemaer endnu. Opret et, og vælg hvilke chatbots der følger det.",
  livechatSchedulesLoadFailed: "Skemaerne kunne ikke hentes.",
  livechatScheduleNew: "Nyt skema",
  livechatScheduleNewName: "Nyt skema",
  livechatScheduleName: "Skemaets navn",
  livechatScheduleTimezone: "Tidszone",
  livechatScheduleChatbotCount: "{count} chatbots",
  livechatScheduleClosureCount: "{count} kommende lukninger",
  livechatScheduleNoClosures: "Ingen lukninger",
  livechatScheduleClosedNow: "Lukket nu: {name}",
  livechatScheduleTabWeekly: "Ugentlige tider",
  livechatScheduleTabClosures: "Helligdage og særlige åbningstider",
  livechatScheduleTabChatbots: "Chatbots",
  livechatScheduleSave: "Gem skema",
  livechatScheduleSaving: "Gemmer…",
  livechatScheduleDelete: "Slet skema",
  livechatScheduleDeleteConfirm:
    "Slet “{name}”? Dets chatbots beholder de ugentlige tider som deres egne. Helligdage og lukninger slettes.",
  livechatScheduleDeleteConfirmAction: "Slet",
  livechatScheduleAll: "Alle skemaer",
  livechatScheduleNameTaken: "Der findes allerede et skema med dette navn.",
  livechatScheduleSaveFailed: "Skemaet kunne ikke gemmes.",
  livechatScheduleChatbotsHelp:
    "Vælger du en chatbot, der følger et andet skema, flyttes den hertil. En chatbot, du fravælger, beholder skemaets tider som sine egne.",
  livechatScheduleChatbotsSave: "Gem chatbots",
  livechatScheduleOnOther: "På {name}",
  livechatScheduleSelected: "{count} af {total} chatbots følger dette skema",
  livechatScheduleUnsaved: "Ikke gemte ændringer",
  livechatClosureAdd: "Tilføj lukning",
  livechatClosureEdit: "Rediger lukning",
  livechatClosureUpcoming: "Kommende",
  livechatClosurePast: "Tidligere",
  livechatClosureShow: "Vis",
  livechatClosureEmpty:
    "Intet planlagt. Tilføj en lukning eller særlige åbningstider på bestemte datoer.",
  livechatClosurePastEmpty: "Ingen tidligere lukninger eller særlige åbningstider.",
  livechatClosureName: "Navn",
  livechatClosureStart: "Startdato",
  livechatClosureEnd: "Slutdato",
  livechatClosureRepeat: "Gentag hvert år",
  livechatClosureHours: "Tider på disse datoer",
  livechatClosureClosedAllDay: "Lukket hele dagen",
  livechatClosureCustomHours: "Særlige åbningstider",
  livechatClosureCustomHelp: "Livechat er kun åben i disse tidsrum på disse datoer.",
  livechatClosureClosedHelp: "Livechat er lukket hele dagen. Chatbotten svarer stadig.",
  livechatClosureAddSlot: "Tilføj tidsrum",
  livechatClosureSlotStart: "Tidsrum {index} åbner",
  livechatClosureSlotEnd: "Tidsrum {index} lukker",
  livechatClosureSlotRemove: "Fjern tidsrum {index}",
  livechatClosureMessage: "Besked, når en besøgende beder om livechat",
  livechatClosureRegularMessage: "Almindelig lukket-besked",
  livechatClosureOwnMessage: "Egen besked",
  livechatClosureRegularHelp: "Botten bruger hver kontaktformulars almindelige lukket-besked.",
  livechatClosureOwnLabel: "Egen besked",
  livechatClosureInsert: "Indsæt",
  livechatClosurePreview: "Tekst, botten bruger den {date}",
  livechatClosureSave: "Gem",
  livechatClosureDelete: "Slet lukning",
  livechatClosureDeleteConfirm: "Slet “{name}”?",
  livechatClosureEveryYear: "Hvert år",
  livechatClosureActive: "Aktiv nu",
  livechatClosureAllDay: "Hele dagen",
  livechatClosureClosed: "Lukket",
  livechatClosureCustom: "Åbent {hours}",
  livechatClosureOwnShort: "Egen besked",
  livechatClosureRegularShort: "Almindelig besked",
  livechatClosureOptions: "Valg for {name}",
  livechatClosureSaveFailed: "Lukningen kunne ikke gemmes.",
  livechatClosureInvalid:
    "Tjek datoer og tider: slutdatoen skal være samme dag som eller efter startdatoen og højst et år senere, og tidsrum må ikke overlappe.",
  livechatClosureLimit: "Skemaet har allerede så mange lukninger, som det kan have.",
  livechatSettingsSchedule: "Åbningstider",
  livechatSettingsScheduleCustom: "Egne tider for denne chatbot",
  livechatSettingsScheduleFollowing:
    "Følger “{name}”. Ændrer du skemaet, gælder det alle {count} chatbots på det.",
  livechatSettingsScheduleEdit: "Rediger skema",
  livechatSettingsScheduleShare: "Del disse tider som et skema",
  livechatSettingsScheduleShareHint:
    "Helligdage og lukninger hører til skemaer. Opret et ud fra disse tider for at tilføje dem.",
  livechatSettingsScheduleSaveFailed: "Skemaet kunne ikke ændres.",
  livechatAvailabilityClosedFor: "{name} til {time}",
  livechatScheduleNameRequired: "Giv skemaet et navn.",
  livechatScheduleTimezoneInvalid: "Ukendt tidszone. Vælg en fra listen, f.eks. Europe/Copenhagen.",
  livechatScheduleDiscardTitle: "Kassér ændringerne?",
  livechatScheduleDiscardText: "Du har ændringer i skemaet, som ikke er gemt.",
  livechatScheduleKeepEditing: "Fortsæt med at redigere",
  livechatScheduleDiscard: "Kassér",
  livechatScheduleReplacesOwnHours:
    "{count} af de valgte chatbots har egne tider. Når du gemmer, får de skemaets tider i stedet, og deres egne tider kan ikke hentes tilbage.",
  livechatSettingsScheduleReplacesOwnHours:
    "Når du gemmer, får chatbotten skemaets tider i stedet for sine egne. Dens egne tider kan ikke hentes tilbage.",
  livechatClosureNameRequired: "Giv lukningen et navn.",
  livechatClosureDatesInvalid:
    "Slutdatoen skal være samme dag som eller efter startdatoen og højst et år senere.",
  livechatClosureNoSlots: "Tilføj mindst ét tidsrum, eller vælg Lukket hele dagen.",
  livechatClosureSlotsInvalid:
    "Hvert tidsrum skal slutte, efter det starter, og tidsrummene må ikke overlappe.",
  livechatScheduleSelectAll: "Vælg alle",
  livechatScheduleSaved: "“{name}” er gemt.",
  livechatScheduleChatbotsSaved: "Chatbots er gemt.",
  livechatClosureSaved: "Lukningen er gemt.",
  livechatSpecialHoursSaved: "De særlige åbningstider er gemt.",
  livechatSpecialHoursAdd: "Tilføj særlige åbningstider",
  livechatSpecialHoursEdit: "Rediger særlige åbningstider",
  livechatScheduleNoChatbots: "Ingen chatbots følger skemaet endnu, så dets tider bruges ikke.",
  livechatScheduleChooseChatbots: "Vælg chatbots",
  livechatTimezoneSearch: "Søg efter tidszone",
  livechatTimezoneEmpty: "Ingen tidszone fundet.",
};
